import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { UserService } from '../../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-telecaller-details-form',
  templateUrl: './telecaller-details-form.component.html',
  styleUrls: ['./telecaller-details-form.component.css']
})
export class TelecallerDetailsFormComponent implements OnInit {

  prospect:any={};
  forwardlist;
data:any;
Proj:any={};
formSubmitted:boolean;
numericpatternti = "[0-9]+";

  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private errorHandler: ErrorHandler) { 
    this.formSubmitted = false;
  }

  ngOnInit() {
    this.GetAllTeleUser();
    
  }


  GetAllTeleUser() {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllTeleUser()
      .subscribe(
        (data: any) => {
          this.Proj=data;
          this.forwardlist = data.ProspectForwardmodels;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  onSubmit(form: NgForm,Proj_Id:any) {
    debugger;
     if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.CreateProspect(form.value,Proj_Id);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('Success!','Propect Details Saved Successfully.', 'success');
         this.router.navigate(['/home/telecaller-alert']);
        }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
    }
    else
    {
    document.getElementById('loader-spinner').style.display = "none";
    swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
    this.formSubmitted = true;
    }
}
}



// WEBPACK FOOTER //
// ./src/app/prospect/telecaller-details/telecaller-details-form/telecaller-details-form.component.ts